<script lang="ts" module>
  export type TimeRangeSettings =
    | false
    | {
        showCustom?: boolean;
      };

  const options = <const>[
    ['DAY', 'Last day'],
    ['WEEK', 'Last week'],
    ['MONTH', 'Last month'],
    ['CUSTOM', 'Custom'],
  ];
</script>

<script lang="ts">
  import { currentTimeRange } from '#lib/timeRange.js';

  let { timeRangeSettings }: { timeRangeSettings: TimeRangeSettings } = $props();
</script>

{#if timeRangeSettings}
  <div class="tabs tabs-sm tabs-box">
    {#each options.slice(0, 3) as [value, label] (value)}
      {@const checked = value === $currentTimeRange}
      <input
        type="radio"
        name="timeRange"
        class={['tab transition-colors', checked ? '[--tab-bg:var(--color-primary)]' : '']}
        aria-label={label}
        {checked}
        onclick={() => currentTimeRange.set(value as 'DAY')}
      />
    {/each}
    {#if timeRangeSettings.showCustom}
      {@const checked = typeof $currentTimeRange === 'object'}
      <div class="border-base-content/20 mx-2 border"></div>
      <input
        type="radio"
        name="timeRange"
        class={['tab', checked ? '[--tab-bg:var(--color-primary)]' : '']}
        aria-label="Custom"
        disabled
        {checked}
      />
    {/if}
  </div>
{/if}
